import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Link from 'components/AppSafeLink/AppSafeLink';
import AdCategoriesContext from 'context/AdCategoriesContext';
import Icon from 'components/Icons/Icon';

const LandingHeading = ({ data }: any) => {
  const config = JSON.parse(data?.resultsConfig?.json);
  const context = useContext(AdCategoriesContext);
  const router = useRouter();

  useEffect(() => {
    context?.setPrimaryCategory('politics/election-2026');
  }, []);

  const fullUrl = `https://www.mprnews.org${router.asPath}`;
  const shareTitle = 'Your Vote Minnesota 26';
  const fbLink = `https://www.facebook.com/sharer.php?u=${fullUrl}`;
  const liLink = `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(
    shareTitle
  )}%20${fullUrl}`;
  const redditLink = `https://reddit.com/submit?url=${fullUrl}&title=${encodeURIComponent(
    shareTitle
  )}`;

  return (
    <section className="election-hub-header">
      <h1 className="invisible">Minnesota Voter Helpdesk</h1>
      <img
        src="/img/election/elections-26.svg"
        alt="Your Vote Minnesota 26"
        width="1200"
        className="election-hub-logo"
      />
      <div className="election-hub-intro">
        MPR News brings you the latest election coverage and results and keeps
        following your elected officials once they take office.
      </div>
      <div className="election-hub-meta-row">
        <div className="election-hub-share">
          <span className="election-hub-share-label">Share:</span>
          <Link
            href={fbLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Share on Facebook - link opens in a new tab"
            className="election-hub-share-facebook"
          >
            <Icon name="facebook" />
          </Link>
          <Link
            href={liLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Share on LinkedIn - link opens in a new tab"
            className="election-hub-share-linkedin"
          >
            <Icon name="linkedin" />
          </Link>
          <Link
            href={redditLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Share on Reddit - link opens in a new tab"
            className="election-hub-share-reddit"
          >
            <Icon name="reddit" />
          </Link>
        </div>
      </div>
    </section>
  );
};

LandingHeading.propTypes = {
  data: PropTypes.object,
};
export default LandingHeading;
